import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys, type ResponseBody } from '../react-query.config';

type AdminLeaguesResponse = ResponseBody<'/api/admin/leagues', 'get'>;
export type League = AdminLeaguesResponse['leagues'][number];

export const getLeagues = async (): Promise<League[]> => {
  const response = await apiClient.get('/api/admin/leagues');
  return response.leagues || [];
};

export const useGetLeaguesQuery = () => {
  return useQuery({
    queryKey: queryKeys.leagues.lists(),
    queryFn: getLeagues,
  });
};
